import Model from "~/models/_Model";
import ComparisonCategory from "./ComparisonCategory";
import ComparisonAssignment from "./ComparisonAssignment";
import ComparisonScore from "./ComparisonScore";

export default class Comparison extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/schoology";
  }

  // Set the resource route of the model
  resource() {
    return "comparisons";
  }

  // Apply model instances to eager loaded relationships
  relations() {
    return {
      categories: ComparisonCategory,
      assignments: ComparisonAssignment,
      scores: ComparisonScore,
    };
  }

  get sort_key() {
    return "";
    //return `${this.display_marking_periods}-${this.period}-${this.display_name}`;
  }

  get categories_result_count() {
    if (!this.categories.results) {
      return 0;
    }
    let count = 0;
    Object.values(this.categories.results).forEach(
      (subResult) => (count += subResult.length)
    );
    return count;
  }
  get assignments_result_count() {
    if (!this.assignments.results) {
      return 0;
    }
    let count = 0;
    Object.values(this.assignments.results).forEach(
      (subResult) => (count += subResult.length)
    );
    return count;
  }
  get scores_result_count() {
    if (!this.scores.results) {
      return 0;
    }
    let count = 0;
    Object.values(this.scores.results[0].student_scores).forEach(
      (subResult) => (count += subResult.length)
    );
    return count;
  }
  get score_comments_result_count() {
    if (!this.scores.results) {
      return 0;
    }
    let count = 0;
    Object.values(this.scores.results[0].student_asmt_comments).forEach(
      (subResult) => (count += subResult.length)
    );
    return count;
  }
}
